module.exports = __webpack_public_path__ + "static/media/act1.68b2ea16.jpg";